import { NavigationItem } from "@common/data-models/service/navigation-item";
import { IDeepCopy } from "@common/interfaces/i-deep-copy";
import { Util } from "@common/utils/util";

export class NavigationSection implements IDeepCopy<NavigationSection> {

    //public static SYSTEM_CURRENT_TOPIC_SECTION_ID: number = -4;
    public static SYSTEM_NEW_SECTION_ID: number = -3;
    public static SYSTEM_SECTION_ID: number = -2;
    public static SYSTEM_DEFAULT_SECTION_ID: number = -1;
    public static SYSTEM_UNASSIGNED_ITEMS_SECTION_ID: number = -100;
    
    public ID: number;
    public Label: string;
    public Order: number;
    public Hidden: boolean;
    public Enterprise: boolean;
    public Items: Array<NavigationItem> = [];
    public Opened: boolean = false;

    public inEditMode: boolean = false;
    public isNewSection: boolean = false;
    public PrevLabel: string;
    public PrevOpened: boolean = false;

    public open() {
        this.Opened = true;
    }

    public close() {
        this.Opened = false;
    }

    public deepCopy(): NavigationSection {
        let section = new NavigationSection();
        section.ID = this.ID;
        section.Label = this.Label;
        section.Order = this.Order;
        section.Hidden = this.Hidden;
        section.Enterprise = this.Enterprise;
        section.Opened = this.Opened;
        section.Items = [];
        
        section.inEditMode = this.inEditMode;
        section.isNewSection = this.isNewSection;
        section.PrevLabel = this.PrevLabel;
        section.PrevOpened = this.PrevOpened;
        
        for (let item of this.Items) {
            section.Items.push(item.deepCopy());
        }
        return section;
    }
}
